export default {
  debtReminders: {
    stopTracking: "Parar acompanhamento",
    stopTrackingHint: "Os envios continuam; o bloqueio de 3 dias é mantido.",
    pending: "Envio em andamento",
    notification: "Notificação",
    neverSent: "Nunca enviado",
    debtCount: "Cobranças",
    notificationHistory: "Notificações de cobrança",
    viewHistory: "Histórico",
    cooldown: "Aguarde 3 dias entre os envios",
    unknown: "Resultado incerto; reenvio bloqueado por 3 dias",
    simulated: "Simulado: nenhum e-mail foi enviado",
    lastAttempt: "Última tentativa",
    nextAllowed: "Próximo envio permitido",
    history: "Histórico de cobrança (últimos 50 envios)",
    noHistory: "Nenhum envio registrado",
    operator: "Solicitado por",
    chargeLink: "Ver cobrança",
    status: {QUEUED: "Agendado",DELIVERED: "Entregue",READ: "Lido",CANCELLED: "Cancelado",PREPARING: "Preparando",SENDING: "Enviando / aguardando confirmação",ACCEPTED: "Aceito pelo serviço de e-mail",FAILED: "Falha confirmada",UNKNOWN: "Resultado incerto",SIMULATED: "Simulado"},
    help: "Selecione as pessoas para enviar um único e-mail por devedor, com todas as suas cobranças vencidas. Os links exigem cobrança online disponível. Até 100 pessoas por envio.",
    select: "Selecionar",
    count: "Movimentações devidas",
    result: "Resultado",
    send: "Enviar e-mail de cobrança",
    filterAll: "Filtrar todas as movimentações",
    missingEmail: "Sem e-mail cadastrado",
    sent: "E-mail enviado",
    noDebt: "Não há mais cobranças vencidas",
    failed: "Falha: confira o e-mail e a disponibilidade dos links de cobrança",
    busy: "Envio já em andamento",
    sendError: "Não foi possível confirmar o envio. Confira o resultado antes de tentar novamente.",
    retry: "Tentar novamente",
  },
	title: "Gestão Finanças",
	subtitle: "Gestão financeira do templo",
	menu: {
		dashboard: "Painel",
		funds: "Fundos",
		movements: "Movimentações",
		reports: "Fechamento",
		integrations: "Integrações",
	},
	categories: {
		title: "Categorias de Fundo",
		newCategory: "Nova Categoria",
		editCategory: "Editar Categoria",
		name: "Nome",
		fundsCount: "Fundos vinculados",
		searchPlaceholder: "Buscar categorias...",
		noCategories: "Nenhuma categoria cadastrada",
		noCategoriesSubtext: "Crie categorias para organizar os fundos do templo",
		confirmDelete: "Tem certeza que deseja excluir a categoria \"{name}\"?",
		stats: {
			total: "Categorias",
		},
		validation: {
			nameRequired: "Nome é obrigatório",
			nameMaxLength: "Nome deve ter no máximo 100 caracteres",
		},
	},
	funds: {
		title: "Fundos",
		newFund: "Novo Fundo",
		editFund: "Editar Fundo",
		name: "Nome",
		category: "Categoria",
		description: "Descrição",
		createCategoryLink: "Criar categoria de fundo",
		recurring: {
			label: "Habilitar cobranças recorrentes",
			hint: "Permite cobrar por pessoa (mensalidade, dízimo) na aba Cobranças. Desligado, o fundo recebe apenas receitas avulsas.",
			disableNote: "Para desabilitar, o fundo não pode ter cobranças ativas.",
		},
		isFeatured: "Destaque",
		color: "Cor",
		isFeaturedHint: "Fundos em destaque aparecem no topo da página com acesso rápido",
		targetAmount: "Meta (R$)",
		deadline: "Prazo",
		isActive: "Ativo",
		perpetual: "Perpétuo",
		goalBased: "Com meta",
		committed: "Previsto",
		collected: "Arrecadado",
		transferred: "Transferido",
		expenses: "Despesas",
		balance: "Saldo",
		groupFlow: "Movimento do período",
		groupStatus: "Situação do fundo",
		period: "Período",
		periodAll: "Acumulado",
		windowMonthly: "por mês",
		accumulatedBalance: "Saldo acumulado",
		windowAccumulated: "acumulado",
		subscribers: "Inscritos",
		noFunds: "Nenhum fundo cadastrado",
		noFundsSubtext: "Crie fundos para gerenciar as receitas do templo",
		searchPlaceholder: "Buscar fundos...",
		featuredFunds: "Em destaque",
		allFunds: "Todos os fundos",
		filters: {
			category: "Categoria",
			status: "Status",
			active: "Ativos",
			inactive: "Inativos",
			clearFilters: "Limpar filtros",
		},
		stats: {
			total: "Fundos",
			active: "Ativos",
			featured: "Destaques",
			totalBalance: "Saldo somado",
		},
		validation: {
			nameRequired: "Nome é obrigatório",
			nameMaxLength: "Nome deve ter no máximo 150 caracteres",
			categoryRequired: "Categoria é obrigatória",
		},
	},
	fundTabs: {
		dashboard: "Dashboard",
		movements: "Movimentações",
		recorrencias: "Recorrências",
		expenses: "Despesas",
	},
	income: {
		title: "Nova Receita",
		modeNow: "Agora",
		modeOpen: "Em aberto",
		modeInstallment: "Parcelado",
		modeRecurring: "Recorrente",
		saved: "Receita registrada com sucesso",
		collisionTitle: "Cobrança em aberto encontrada",
		collisionText: "{name} já tem {count} cobrança(s) em aberto neste fundo e mês ({amount}). O que deseja fazer?",
		settleIt: "Dar baixa nela",
		createAnyway: "Criar receita nova",
	},
	sales: {
		title: "Entradas",
		newSale: "Nova Receita",
		description: "Descrição",
		descriptionHint: "Do que se refere (ex: doação, mensalidade extra, venda, rifa)",
		saleDate: "Data",
		personOptionalHint: "Opcional — deixe em branco para entrada não identificada",
		saved: "Lançamento registrado com sucesso",
		searchPlaceholder: "Buscar por descrição ou pessoa...",
		noSales: "Nenhuma entrada registrada",
		noSalesSubtext: "Registre entradas avulsas deste fundo (doações, vendas, arrecadações)",
		totalThisView: "Total",
		modePaid: "Pago agora",
		modeOpen: "Em aberto (a receber)",
		filterAll: "Todos",
		filterOpen: "Em aberto",
		filterPaid: "Pagos",
		totalOpen: "Em aberto",
		totalReceived: "Recebido",
	},
	charges: {
		title: "Cobranças",
		subscriptions: "Inscrições",
		newCharge: "Criar Cobrança",
		batchCharge: "Cobrança em lote",
		batchChargeTitle: "Cobrança em lote",
		batchChargeCreated: "{count} cobranças criadas",
		batchChargePartial: "{success} de {total} cobranças criadas",
		batchChargeAllFailed: "Não foi possível criar as cobranças",
		searchPerson: "Buscar pessoa...",
		person: "Pessoa",
		people: "Pessoas",
		amount: "Valor",
		mode: "Modo",
		recurring: "Recorrente",
		oneTime: "Parcelado",
		lumpSum: "À vista",
		lumpSumDesc: "Será criada uma única cobrança.",
		recurringDesc: "Será criada uma cobrança a cada mês.",
		oneTimeDesc: "Será cobrada uma parcela a cada mês.",
		dueDay: "Vencimento",
		dueDayHint: "Dia do mês para vencimento (1-28)",
		nextChargeHint: "Próxima mensalidade: gerada em {generated}, com vencimento em {due}",
		installments: "Parcelas",
		firstImmediate: "Primeira parcela vence hoje",
		exempt: "Isentar",
		unexempt: "Remover isenção",
		exemptReason: "Motivo da isenção",
		exemptNotes: "Observações (dado sensível)",
		deactivate: "Desativar cobrança",
		reactivate: "Reativar",
		noCharges: "Nenhuma cobrança neste fundo",
		noChargesSubtext: "Crie cobranças para gerenciar pagamentos",
		status: {
			active: "Ativa",
			exempt: "Isenta",
			inactive: "Inativa",
		},
		reasons: {
			FINANCIAL: "Financeiro",
			HEALTH: "Saúde",
			SENIOR: "Idoso",
			LEADERSHIP: "Liderança",
			OTHER: "Outro",
		},
		editCharge: "Editar Cobrança",
		editRecurrence: "Editar recorrência",
		history: "Histórico",
		historyTitle: "Histórico de Alterações",
		noHistory: "Nenhuma alteração registrada",
		historyFields: {
			amount: "Valor",
			dueDay: "Vencimento",
			installments: "Parcelas",
		},
		maxInstallmentsHint: "Máximo {n} parcelas (prazo do fundo: {date})",
		enrollExempt: "Criar como isenta",
		viewRecurrences: "Recorrências",
		viewCalendar: "Calendário",
		newOpenCharge: "Nova cobrança em aberto",
		chargeCreated: "Cobrança em aberto criada",
		dueDate: "Vencimento",
		personOpenHint: "Quem vai acertar essa cobrança",
		pay: "Dar baixa",
		payCharge: "Dar baixa",
		chargePaid: "Baixa registrada",
		validation: {
			personRequired: "Pessoa é obrigatória",
			personsRequired: "Selecione ao menos uma pessoa",
			amountRequired: "Valor é obrigatório",
			installmentsRequired: "Número de parcelas é obrigatório para parcelado",
			installmentsExceedDeadline: "O número de parcelas excede o prazo do fundo ({date})",
			exemptReasonRequired: "Motivo da isenção é obrigatório",
			descriptionRequired: "Descrição é obrigatória",
			dueDayRange: "Informe um dia entre 1 e 28",
			dueDateRequired: "Vencimento é obrigatório",
			dueDatePast: "Vencimento não pode ser no passado",
		},
	},
	movements: {
		reversedTrail: "Motivo do estorno",
		title: "Movimentações",
		registerPayment: "Registrar Pagamento",
		amount: "Valor",
		amountPaid: "Valor pago",
		method: "Método",
		referenceMonth: "Mês de referência",
		notes: "Observações",
		anonymous: "Anônimo",
		anonymousHint: "Deixe em branco para modo anônimo",
		fund: "Fundo",
		amountBelowCommitted: "Atenção: valor menor que o previsto ({amount})",
		earlierMonthUnpaid: "Atenção: há meses anteriores não pagos",
		effectiveDate: "Data efetiva",
		cancel: "Cancelar pagamento",
		confirmCancel: "Tem certeza que deseja cancelar este pagamento?",
		reverse: "Estornar lançamento",
		reverseShort: "Estornar",
		confirmReverse: "Estornar este lançamento?",
		reversalReason: "Motivo do estorno",
		reopenCharge: "Voltar a cobrança para pendente",
		reopenChargeHint: "A pessoa volta a dever este mês.",
		status: {
			PENDING: "Pendente",
			PAID: "Pago",
			OVERDUE: "Atrasado",
			WAIVED: "Dispensado",
			CANCELLED: "Cancelado",
			REVERSED: "Estornado",
			FORGIVEN: "Perdoado",
		},
		methods: {
			CASH: "Dinheiro",
			PIX: "PIX",
			TRANSFER: "Transferência",
			OTHER: "Outro",
		},
		noMovements: "Nenhuma movimentação",
		attachment: "Comprovante",
		attachmentHint: "Anexe uma foto do comprovante (opcional)",
		residualForgiveWarning: "O valor digitado é menor que o cobrado. A diferença será perdoada — nenhuma cobrança adicional será gerada.",
		residualCheckboxLabel: "Gerar cobrança pelo saldo restante ({amount})",
		residualCheckboxHint: "Cria uma nova cobrança pendente para a pessoa pagar depois. Se desmarcado, a diferença é perdoada.",
		residualAlwaysInfo: "Será gerada automaticamente uma cobrança pelo saldo restante ({amount}).",
		forgivenReasonLabel: "Motivo do perdão de {amount}",
		forgivenReasonHint: "Obrigatório: a casa está abrindo mão deste valor, e a prestação de contas precisa dizer por quê.",
		partialSettleTrail: "Baixa parcial",
		chargedAmount: "Valor cobrado",
		receivedAmount: "Valor recebido",
		forgivenAmount: "Perdão de cobrança",
		residualAmount: "Saldo restante",
		forgivenReasonTitle: "Motivo do perdão",
		validation: {
			forgivenReasonRequired: "Informe o motivo do perdão",
			amountRequired: "Valor é obrigatório",
			methodRequired: "Método é obrigatório",
			referenceMonthRequired: "Mês de referência é obrigatório",
			fundRequired: "Fundo é obrigatório",
		},
	},
	movementFilters: {
		transfers: "Transferências",
		transferHint: "As transferências aparecem no total Transferido e no saldo realizado. Elas não compõem Recebido ou Pago.",
		applyHint: "Escolha o intervalo e clique em Aplicar. Os chips abaixo mostram os filtros em uso.",
		period: "Período",
		dateBasis: "Data considerada",
		type: "Tipo",
		situation: "Situação",
		from: "De",
		to: "Até",
		apply: "Aplicar",
		invalidRange: "Informe um intervalo válido, com início anterior ou igual ao fim.",
		search: "Buscar pessoa, descrição ou código…",
		more: "Mais filtros",
		method: "Forma de pagamento",
		minAmount: "Valor mínimo",
		maxAmount: "Valor máximo",
		invalidAmounts: "Informe valores válidos, com mínimo menor ou igual ao máximo.",
		all: "Todo o histórico",
		current: "Este mês",
		previous: "Mês anterior",
		custom: "Personalizado",
		reference: "Competência",
		due: "Vencimento",
		paid: "Pagamento",
		quickOverdue: "A receber vencido",
		quickOverdueExpense: "Contas a pagar vencidas",
		quickDueSoon: "Vence em 7 dias",
		quickWeek: "A pagar nesta semana",
		quickWeekIncome: "A receber esta semana",
		quickToday: "Movimentado hoje",
		quickPaid: "Pagos neste mês",
	},
	movementsPage: {
		exportCsv: "Exportar CSV",
		printReport: "Imprimir",
		reportCount: "{count} de {total} registros dos filtros selecionados (limite: 2.000).",
		reportError: "Não foi possível gerar o relatório. Tente novamente.",
		income: "Entrada",
		expense: "Saída",
		title: "Movimentações",
		subtitle: "Extrato geral de receitas, despesas e transferências",
		searchPerson: "Buscar por pessoa...",
		allTypes: "Todos os tipos",
		allFunds: "Todos os fundos",
		allCategories: "Todas as categorias",
		allStatuses: "Todos os status",
		typeIncome: "Receita",
		typeExpense: "Despesa",
		typeTransfer: "Transferência",
		noMovements: "Nenhuma movimentação encontrada",
		noMovementsSubtext: "Registre receitas, despesas ou transferências para visualizar o extrato",
		type: "Tipo",
		clearFilters: "Limpar filtros",
		dueWindow: "Vencimento: {from} a {to}",
		totalsOfFilter: "Total do filtro:",
		totalReceived: "Recebido",
		totalToReceive: "A receber",
		totalPaid: "Pago",
		totalToPay: "A pagar",
		realizedBalance: "Saldo realizado",
		uncountedNotice: "Fora destes totais: {count} (estornado, cancelado ou dispensado)",
		columns: {
			date: "Data",
			code: "Código",
			type: "Tipo",
			person: "Pessoa",
			fund: "Fundo",
			category: "Categoria",
			referenceMonth: "Mês Ref.",
			amount: "Valor",
			method: "Método",
			status: "Status",
			description: "Descrição",
		},
		anonymous: "Anônimo",
	},
	grid: {
		title: "Contribuições",
		member: "Membro",
		noData: "Nenhum dado para exibir",
		noDataSubtext: "Inscreva pessoas neste fundo para ver o grid",
		paymentDetail: "Detalhes do Pagamento",
		tooltipPaid: "Pago — clique para ver detalhes",
		tooltipPending: "Pendente — clique para registrar",
		tooltipOverdue: "Atrasado — clique para registrar",
		tooltipWaived: "Dispensado",
		tooltipExempt: "Isento",
		tooltipCancelled: "Cancelado",
		tooltipReversed: "Estornado",
		tooltipSettledInMonth: "Paga em {month} — a cobrança é desta competência, o dinheiro entrou naquele mês",
		tooltipForgivenInMonth: "Perdoada em {month} — a cobrança é desta competência; a casa abriu mão dela naquele mês",
		tooltipEmpty: "Sem movimentação — clique para registrar",
		avulsa: "Avulsa",
		chargesTitle: "Cobranças",
		seeInMovements: "Ver movimentações desta pessoa",
		monthClosed: "Mês fechado — não é possível criar lançamentos",
		multipleCharges: "{count} cobranças neste mês",
		newCharge: "Nova cobrança",
		months: {
			"10": "Out",
			"11": "Nov",
			"12": "Dez",
			"01": "Jan",
			"02": "Fev",
			"03": "Mar",
			"04": "Abr",
			"05": "Mai",
			"06": "Jun",
			"07": "Jul",
			"08": "Ago",
			"09": "Set",
		},
	},
	personFinancial: {
		title: "Financeiro",
		noHistory: "Sem histórico financeiro",
		noHistorySubtext: "Pagamentos desta pessoa aparecerão aqui",
		totalPaid: "Total pago",
		totalPending: "Total pendente",
		totalOverdue: "Total em atraso",
		paidAt: "Data pgto.",
	},
	dashboard: {
		monthlyCollected: "Arrecadado no Mês",
		goalPercent: "Meta Atingida",
		remaining: "Faltam",
		overdueCount: "Inadimplentes",
		featuredFunds: "Fundos em Destaque",
		receivableTitle: "Contas a Receber",
		payableTitle: "Contas a Pagar",
		viewMovements: "Ver",
		delinquentHint: "Cobranças vencidas das pessoas inadimplentes, de todos os meses. O painel conta pessoas; cada linha aqui é uma cobrança.",
		bucket: {
			overdue: "Vencidas",
			dueIn7Days: "Vencem em 7 dias",
			dueAfter7Days: "Vencem após 7 dias",
			open: "Total",
		},
		committed: "Previsto",
		collected: "Arrecadado",
		noFeatured: "Nenhum fundo em destaque",
		delinquents: "Membros Inadimplentes",
		noDelinquents: "Nenhum membro inadimplente",
		totalDue: "Total Devido",
		monthsOverdue: "meses em atraso",
		noChartData: "Sem dados para exibir o gráfico",
	},
	/**
	 * A VÁLVULA DE CAIXA (ISSUE-034): a cobrança de um mês fechado não vira paga
	 * naquele mês — nasce um recibo no mês aberto, e o documento já prestado em
	 * assembleia continua dizendo o que disse.
	 */
	settlement: {
		valveNotice:
			"O recibo entra em {openMonth}; o caixa de {originMonth}, já fechado, permanece igual.",
		valveNoticeByDueDate:
			"O recibo entra em {openMonth}; o caixa de {closedMonth}, fechado no vencimento, permanece igual.",
		integralOnly:
			"Mês fechado: só quitação integral. Para parte ou perdão, use Perdoar.",
		settledInMonth: "Paga em {month}",
		settledInMonthHint: "A cobrança continua nesta competência; o dinheiro entrou em {month}.",
		legendSettledInMonth: "Paga em outro mês (competência fechada)",
		receiptOf: "Recebimento da competência {month}",
		forgivenInMonth: "Perdoado",
		forgivenInMonthHint: "Perdoada em {month}; a competência não muda.",
		forgivenPartialHint: "Recebido; o restante foi perdoado",
		forgivenReason: "Motivo do perdão",
		legendForgivenInMonth: "Perdoado",
		forgivenessOf: "Perdão da competência {month}",
		forgivenessOfHint: "Cobrança de origem #{code}, de {month}.",
		closedPeriodForgiveness: {
			title: "Perdões de competências fechadas",
			hint: "Detalhe por competência de origem. Já conta em Perdão de cobrança.",
			column: "Competência de origem",
			received: "Recebido",
			forgiven: "Perdoado",
			full: "Integral",
			partial: "Parcial",
		},
		closedPeriodReceipts: {
			title: "Recebimentos de competências fechadas",
			hint: "Já somados na receita do mês. As cobranças de origem estão quitadas; o caixa permanece no mês do recebimento.",
			column: "Competência de origem",
		},
	},
	/**
	 * PERDÃO DE COBRANÇA DE MÊS FECHADO (ISSUE-036, o caso do Rubens): a casa
	 * abre mão de uma dívida antiga sem mexer no mês fechado — nasce um lançamento
	 * de perdão no mês aberto, apontando para a cobrança original.
	 */
	forgiveness: {
		title: "Perdoar cobrança de mês fechado",
		action: "Perdoar",
		actionTooltip: "Perdoar cobrança de mês fechado",
		insteadOfPaying: "Perdoar em vez de receber",
		notice:
			"Cobrança de {originMonth}, mês fechado. O perdão entra em {openMonth}; {originMonth} não muda.",
		noticeByDueDate:
			"Vencida em {closedMonth}, mês fechado. O perdão entra em {openMonth}; {closedMonth} não muda.",
		reasonLabel: "Motivo do perdão",
		reasonHint: "Fica registrado na prestação de contas",
		reasonRequired: "Informe o motivo do perdão",
		partialSwitch: "Recebi uma parte",
		amountLabel: "Valor recebido",
		amountInvalid: "Maior que zero e menor que o cobrado",
		methodRequired: "Informe o método",
		forgivenSummary: "Perdoado: {amount}",
		receivedSummary: "Recebido: {amount}",
		success: "Cobrança perdoada. Lançamento em {month}.",
		confirm: "Perdoar",
	},
	report: {
		title: "Relatório",
		searchPerson: "Buscar pessoa...",
		totalCollected: "Total Arrecadado",
		totalCommitted: "Total Previsto",
		adherence: "Aderência",
		adherenceNoBase: "sem cobrança encerrada",
		chargesActive: "Cobranças ativas",
		allMovements: "Movimentações",
		registeredBy: "Registrado por",
		timeProgress: "Progresso no Tempo",
		elapsed: "Decorrido",
		remaining: "Restante",
		chartTitle: "Arrecadação Mensal",
		noChartData: "Sem dados para exibir o gráfico",
	},
	insights: {
		analysisTitle: "Análise do período",
		periodAll: "Todo o histórico",
		periodLast6: "Últimos 6 meses",
		periodLast12: "Últimos 12 meses",
		periodCustom: "Período personalizado",
		startMonth: "De",
		endMonth: "Até",
		applyPeriod: "Aplicar",
		invalidRange: "O mês inicial deve ser anterior ou igual ao mês final.",
		appliedPeriod: "Período exibido",
		periodScope: "aplicado aos cards e gráficos abaixo",
		pendingTitle: "Pendências atuais",
		pendingHint: "Situação de hoje, considerando todos os meses. Este bloco não acompanha o filtro de período.",
		flowHint: "Entradas e saídas pagas por competência, incluindo transferências. Compare os valores para entender a variação do saldo.",
		prevRealHint: "Valor previsto nas cobranças vinculadas a inscrições e quanto já foi pago em cada competência. O mês atual ainda está em andamento.",
		adherenceHint: "Percentual do valor previsto nas cobranças vinculadas a inscrições que já foi pago. Meses sem previsão ficam sem ponto; o mês atual ainda pode evoluir.",
		agingHint: "Valores em aberto de todos os meses, agrupados pelo atraso no vencimento. “Em dia” inclui cobranças ainda não vencidas ou sem vencimento definido.",
		topDebtorsHint: "As cinco pessoas com maior valor em aberto, considerando todos os meses e incluindo cobranças ainda não vencidas.",
		methodHint: "Distribuição das receitas pagas por forma de pagamento nas competências exibidas, sem transferências entre fundos.",
		categoryHint: "Distribuição das despesas pagas e classificadas por categoria no período exibido. Despesas sem categoria ficam fora deste gráfico.",
		balanceEvolutionTitle: "Evolução do saldo do fundo",
		balanceEvolutionHint: "Saldo por competência, incluindo transferências. Pagamentos de competências futuras aparecem no respectivo mês. Mês atual em andamento.",
		zeroBalance: "Saldo zero",
		currentPosition: "Situação atual · todos os meses",
		adherenceTitle: "Aderência mensal",
		agingTitle: "Inadimplência por atraso",
		flowTitle: "Entradas e saídas",
		methodTitle: "Recebido por método",
		open: "Em aberto",
		balance: "Saldo",
		income: "Entradas",
		expense: "Saídas",
		agingCurrent: "Em dia",
		aging1_30: "1–30 dias",
		aging31_60: "31–60 dias",
		aging60plus: "60+ dias",
		noData: "Sem dados para exibir",
		noOpen: "Nenhuma cobrança em aberto",
		prevRealTitle: "Previsto × Realizado",
		expected: "Previsto",
		received: "Recebido",
		topDebtorsTitle: "Maiores devedores",
		cumulativeTitle: "Saldo acumulado",
		categoryTitle: "Despesas por categoria",
	},
	settings: {
		title: "Configurações",
	},
	expenseCategories: {
		title: "Categorias de Despesa",
		newCategory: "Nova Categoria",
		editCategory: "Editar Categoria",
		searchPlaceholder: "Buscar categoria...",
		noCategories: "Nenhuma categoria de despesa",
		noCategoriesSubtext: "Crie categorias para classificar as despesas do terreiro",
		movementsCount: "movimentações",
		confirmDelete: "Tem certeza que deseja excluir a categoria \"{name}\"?",
		stats: {
			total: "Total",
		},
	},
	expenses: {
		registerExpense: "Registrar Despesa",
		category: "Categoria de Despesa",
		fromFund: "De qual fundo sai",
		description: "Descrição",
		descriptionPlaceholder: "Ex: Conta de luz fevereiro, 10kg de arroz...",
		register: "Registrar",
		validation: {
			categoryRequired: "Categoria é obrigatória",
		},
		scheduleExpense: "Agendar Despesa",
		payNow: "Pagar agora",
		scheduleLater: "Agendar",
		recurring: "Recorrente",
		dueDate: "Data de vencimento",
		dueDateRequired: "Data de vencimento é obrigatória para despesas agendadas",
		scheduledSuccess: "Despesa agendada com sucesso",
		payExpense: "Pagar despesa",
		expensePaid: "Despesa paga com sucesso",
		methodRequiredForPayment: "Método de pagamento é obrigatório",
	},
	recurringExpenses: {
		title: "Despesas Recorrentes",
		newExpense: "Nova Despesa Recorrente",
		editExpense: "Editar Despesa Recorrente",
		name: "Nome",
		namePlaceholder: "Ex: Aluguel, Conta de Luz...",
		category: "Categoria",
		fund: "Fundo de saída",
		dueDay: "Dia de vencimento",
		dueDayHint: "Dia do mês (1-28)",
		expectedAmount: "Valor esperado",
		isFixed: "Valor fixo",
		isVariable: "Valor variável",
		fixedHint: "O valor é sempre o mesmo todo mês",
		variableHint: "O valor pode mudar a cada mês (ex: conta de luz)",
		startDate: "Data de início",
		endDate: "Data de fim",
		endDateHint: "Deixe em branco para recorrência indefinida",
		active: "Ativa",
		inactive: "Inativa",
		deactivate: "Desativar",
		activate: "Ativar",
		editRecurring: "Editar recorrência",
		noExpenses: "Nenhuma despesa recorrente",
		noExpensesSubtext: "Cadastre despesas que se repetem todo mês, como aluguel, luz e internet",
		searchPlaceholder: "Buscar despesas recorrentes...",
		generatedMovements: "Movimentações geradas",
		validation: {
			nameRequired: "Nome é obrigatório",
			categoryRequired: "Categoria é obrigatória",
			fundRequired: "Fundo é obrigatório",
			dueDayRequired: "Dia de vencimento é obrigatório",
			amountRequired: "Valor é obrigatório",
			startDateRequired: "Data de início é obrigatória",
		},
		messages: {
			created: "Despesa recorrente criada com sucesso",
			updated: "Despesa recorrente atualizada com sucesso",
			deactivated: "Despesa recorrente desativada",
			activated: "Despesa recorrente ativada",
		},
	},
	transfers: {
		title: "Transferência",
		fromFund: "Fundo de Origem",
		toFund: "Fundo de Destino",
		description: "Descrição",
		descriptionPlaceholder: "Ex: Transferência para fundo de festa...",
		transfer: "Transferir",
		balance: "Saldo",
		negativeBalanceWarning: "Atenção: esta transferência deixará o fundo de origem com saldo negativo.",
		percentOfBalance: "Percentual do saldo",
		validation: {
			fromFundRequired: "Fundo de origem é obrigatório",
			toFundRequired: "Fundo de destino é obrigatório",
			sameFund: "Fundos de origem e destino devem ser diferentes",
			percentRange: "Informe um valor entre 1% e 100%",
		},
	},
	cashFlow: {
		totalBalance: "Saldo Total",
		monthIncome: "Entradas do Mês",
		monthExpense: "Saídas do Mês",
		monthBalance: "Saldo do Mês",
		chartTitle: "Fluxo de Caixa — Entradas vs Saídas",
		income: "Entradas",
		expense: "Saídas",
		balance: "Saldo Acumulado",
	},
	messages: {
		categoryCreated: "Categoria criada com sucesso",
		categoryUpdated: "Categoria atualizada com sucesso",
		categoryDeleted: "Categoria excluída com sucesso",
		expenseCategoryCreated: "Categoria de despesa criada com sucesso",
		expenseCategoryUpdated: "Categoria de despesa atualizada com sucesso",
		expenseCategoryDeleted: "Categoria de despesa excluída com sucesso",
		fundCreated: "Fundo criado com sucesso",
		fundUpdated: "Fundo atualizado com sucesso",
		errorLoading: "Erro ao carregar dados financeiros",
		chargeCreated: "Cobrança criada com sucesso",
		chargeExempted: "Isenção aplicada com sucesso",
		chargeUnexempted: "Isenção removida com sucesso",
		chargeReactivated: "Cobrança reativada com sucesso",
		paymentRegistered: "Pagamento registrado com sucesso",
		chargeUpdated: "Cobrança atualizada com sucesso",
		paymentCancelled: "Pagamento cancelado com sucesso",
		paymentReversed: "Pagamento estornado com sucesso",
		expenseRegistered: "Despesa registrada com sucesso",
		transferCompleted: "Transferência realizada com sucesso",
		movementUpdated: "Movimentação atualizada com sucesso",
	},
	closing: {
		title: "Fechamento Mensal",
		subtitle: "Controle de fechamento e relatórios mensais",
		close: "Fechar Mês",
		reopen: "Reabrir Mês",
		confirmClose: "Tem certeza que deseja fechar o mês {month}? Ninguém poderá criar, editar ou estornar movimentação deste mês pelo sistema.",
		confirmReopen: "Tem certeza que deseja reabrir o mês {month}?",
		reopenLosesProof: "Reabrir APAGA o hash de integridade deste mês: um relatório já impresso deixa de ser verificável contra o sistema. A observação escrita no fechamento também será substituída pela que você digitar abaixo.",
		notes: "Observações",
		notesPlaceholder: "Motivo do fechamento/reabertura...",
		closingPreview: {
			heading: "Ao fechar {month}, isto fica para trás:",
			charges: "{count} cobrança(s) a receber — {amount}",
			expenses: "{count} conta(s) a pagar — {amount}",
			consequence: "Fechar não cancela nada: a dívida e a conta continuam. O que for recebido ou pago depois é lançado no mês aberto em que for registrado, e os lançamentos e os totais de {month} não mudam.",
		},
		status: {
			OPEN: "Aberto",
			CLOSED: "Fechado",
		},
		report: {
			title: "Relatório Mensal",
			incomeByFund: "Receita por Fundo",
			expenseByCategory: "Despesa por Categoria",
			byMethod: "Recebimentos por Método",
			delinquents: "Inadimplentes",
			comparison: "Comparação com Mês Anterior",
			noData: "Nenhum dado para este mês",
			delta: "Variação",
			income: "Receita",
			expense: "Despesa",
			balance: "Saldo",
			total: "Total",
			previousMonth: "Mês Anterior",
			openingBalance: "Saldo anterior",
			movementCount: "Movimentações",
			closedBy: "Fechado por {user} em {date}",
			reopenedBy: "Reaberto por {user} em {date}",
			noNotes: "Nenhuma observação foi registrada.",
			previousClosings: "Fechamentos anteriores deste mês",
			previousClosingsHint: "Cada reabertura encerra o fechamento anterior. O código de integridade abaixo é o que foi impresso nos relatórios daquela época — ele continua válido para aquela versão, ainda que o mês tenha sido fechado de novo depois.",
			versionNumber: "Fechamento {number}",
			supersededBy: "Reaberto por {user} em {date}",
			waived: "Isentos",
			forgiven: "Perdão de cobrança",
			closingBalance: "Saldo final acumulado",
		},
		partial: "Parcial",
		partialBanner: "Este relatório é parcial — o mês ainda está em andamento.",
		closeSequential: "Feche o mês {month} antes de fechar este.",
		isClosable: "Pronto para fechamento",
		viewReport: "Ver Relatório",
		backToList: "Voltar",
		recipients: {
			title: "Email de fechamento mensal",
			description: "Enviar relatório por email ao fechar o mês",
			admins: "Administradores",
			allUsers: "Todos os usuários",
			corrente: "Membros da corrente",
		},
		messages: {
			monthClosed: "Mês fechado com sucesso",
			monthReopened: "Mês reaberto com sucesso",
			error: "Erro ao processar fechamento",
		},
	},
	payment: {
		title: "Pagamentos online",
		feeConfig: {
			title: "Lançamento da taxa do Mercado Pago",
			description:
				"O Mercado Pago cobra uma taxa por transação (PIX 0,99%, cartão ~4,98%) e a desconta antes de o dinheiro chegar à conta do templo — ou seja, entra menos do que o membro pagou. Para a prestação de contas ficar correta, o ORI mantém o pagamento pelo valor cheio e lança automaticamente essa diferença como uma despesa \"Taxa Mercado Pago\", vinculada ao movimento de origem. Assim, o saldo do fundo reflete exatamente o valor líquido que realmente entrou.",
			example:
				"Exemplo: o membro paga R$ 50,00 via PIX → o templo recebe R$ 49,50 e o ORI registra uma despesa de R$ 0,50 (\"Taxa Mercado Pago - mov 260100\"). O saldo do fundo mostra os R$ 49,50 que de fato entraram.",
			enabledLabel: "Lançar a taxa do Mercado Pago como despesa",
			fundSame: "No mesmo fundo que recebeu o pagamento",
			fundFixed: "Sempre em um fundo específico",
			fundSelect: "Fundo da despesa da taxa",
			noFunds: "Nenhum fundo cadastrado",
			disableTitle: "Desativar o lançamento da taxa?",
			disableWarning:
				"Recomendamos fortemente manter esta opção ativa.\n\nSem o lançamento da taxa, o saldo dos seus fundos ficará superestimado: o sistema vai registrar o valor cheio cobrado do membro, mas a conta do templo no Mercado Pago receberá menos, porque a taxa já foi descontada. A prestação de contas deixará de refletir o dinheiro que de fato entrou.\n\nDesative apenas se você tem plena consciência dessa distorção e pretende conciliar a taxa manualmente.",
			disableConfirm: "Desativar mesmo assim",
			saveSuccess: "Configuração da taxa salva",
			saveError: "Falha ao salvar a configuração da taxa",
		},
		autoDebitConfig: {
			enabledLabel: "Permitir cobrança automática (débito recorrente no cartão)",
			description:
				"Quando ativo, os membros podem autorizar o débito automático mensal e você pode ativá-lo nas cobranças. Desligado, fica só o PIX — o botão de cobrança automática deixa de aparecer. Débitos automáticos já autorizados continuam ativos e podem ser pausados ou cancelados.",
			saveSuccess: "Preferência de cobrança automática salva",
			saveError: "Falha ao salvar a preferência de cobrança automática",
		},
		consent: {
			title: "Antes de conectar o Mercado Pago",
			intro:
				"Ao conectar sua conta, os pagamentos dos membros passam a ser processados pelo Mercado Pago. Antes de continuar, confirme que está ciente de que:",
			fees:
				"O Mercado Pago cobra uma taxa por transação (PIX 0,99%, cartão de crédito ~4,98%), descontada automaticamente. O ORI não cobra nada a mais.",
			netAmount:
				"O valor depositado na conta do templo será menor do que o valor pago pelo membro, pois a taxa é descontada antes da liberação.",
			feeExpense:
				"O ORI lança automaticamente essa taxa como uma despesa \"Taxa Mercado Pago\" no financeiro, para que o saldo dos fundos reflita o valor líquido recebido (ajustável nas configurações da integração).",
			responsibility:
				"As taxas, prazos de liberação e políticas são de responsabilidade do Mercado Pago, não do ORI. Você é responsável pela conta conectada e pela conferência dos valores recebidos.",
			checkbox: "Li e estou de acordo com as condições acima.",
			confirm: "Conectar Mercado Pago",
		},
		connect: "Conectar Mercado Pago",
		disconnect: "Desconectar",
		connected: "Conectado",
		connectedAs: "Conta: {account}",
		fees: "Taxas do Mercado Pago: PIX 0,99% · cartão ~4,98% (~3,98% após 30 dias). O ORI não cobra nada a mais.",
		expired: "Expirado",
		revoked: "Desconectado",
		notConnected: "Nenhuma conta de pagamento conectada",
		moduleMissing:
			"O ORI Pagamentos (integração Mercado Pago) não está incluído no seu plano. Contrate o módulo na tela do plano para conectar.",
		connectRequired: "Conecte o Mercado Pago em Integrações para usar esta função",
		connectSuccess: "Conta de pagamento conectada com sucesso",
		connectError: "Falha ao conectar a conta de pagamento",
		charge: {
			button: "Cobrar online",
			generating: "Gerando cobrança...",
			copyLink: "Copiar link",
			linkCopied: "Link copiado",
			created: "Cobrança gerada",
			error: "Falha ao gerar a cobrança",
			emailSent: "Enviado por e-mail para",
		},
		mandate: {
			enable: "Cobrança automática",
			column: "Cobrança automática",
			manualBlocked:
				"Esta mensalidade está em débito automático — o Mercado Pago debita automaticamente. Não é possível registrar pagamento manual. Pause o débito automático para cobrar de outra forma.",
			manualBlockedShort: "Em débito automático — pagamento manual bloqueado",
			pauseToPayManually: "Pausar débito automático",
			activate: "Ativar cobrança automática",
			resendLink: "Reenviar link de autorização",
			pause: "Pausar",
			resume: "Retomar",
			cancel: "Cancelar cobrança automática",
			pausedSuccess: "Débito automático pausado",
			resumedSuccess: "Débito automático retomado",
			cancelledSuccess: "Débito automático cancelado",
			authorizePrompt: "Ative a cobrança automática mensal desta mensalidade.",
			confirmCancelTitle: "Cancelar cobrança automática?",
			confirmCancelText:
				"O débito automático mensal deixará de acontecer. Você poderá ativar novamente depois.",
			state: {
				NONE: "Cobrança automática: desligada",
				PENDING: "Aguardando o membro autorizar",
				AUTHORIZED: "Cobrança automática: ativa",
				PAUSED: "Cobrança automática: pausada",
			},
			tip: {
				NONE: "Cobrança automática desligada. Ative para o membro autorizar o débito mensal.",
				PENDING: "Aguardando o membro autorizar o débito automático pelo link enviado.",
				AUTHORIZED:
					"Cobrança automática ativa — o membro é debitado todo mês. Pausar interrompe sem cancelar.",
				PAUSED: "Cobrança automática pausada — os débitos estão suspensos. Retome para voltar a cobrar.",
			},
		},
		status: {
			PENDING: "Pendente",
			AUTHORIZED: "Autorizada",
			PAUSED: "Pausada",
			CANCELLED: "Cancelada",
			PAID: "Pago",
			EXPIRED: "Expirado",
			FAILED: "Falhou",
		},
	},
	pay: {
		loading: "Carregando...",
		notFound: "Link de pagamento não encontrado ou indisponível",
		autoMandateTitle: "Cansado de pagar todo mês?",
		autoMandateText:
			"Ative o débito automático e não precise mais pagar manualmente — você autoriza uma vez e pronto.",
		enableAutoMandate: "Ativar débito automático",
		autoMandateError: "Não foi possível ativar o débito automático. Tente novamente.",
		title: "Pagamento",
		amount: "Valor",
		temple: "Templo",
		month: "Mês",
		payWith: "Pagar com",
		pixTab: "PIX copia e cola",
		cardTab: "Cartão",
		copyCode: "Copiar código PIX",
		codeCopied: "Código copiado!",
		paid: "Pagamento confirmado",
		expiredHint: "O código PIX tem validade limitada. Gere um novo para pagar agora.",
		noPaymentDue: "Esta cobrança foi encerrada. Não há pagamento a realizar.",
		forgiven: "Cobrança perdoada pela casa. Nada a pagar.",
		generateNewPix: "Gerar novo PIX",
		generateNewPixError: "Não foi possível gerar um novo PIX. Tente novamente.",
		expired: "Este código PIX expirou",
		authorize: "Autorizar cobrança automática",
		pixExpiryNotice: "Este código PIX expira {time}. Não faça agendamento.",
		autoDebitUnavailable:
			"A cobrança automática não está mais disponível neste templo. Fale com a administração para combinar outra forma de pagamento.",
	},
};
